export default {
    // "feast": require("./feast").default,
    // "book": require("./book").default,
    // "hero": require("./hero").default,
    "dice": require("./dice").default,
    // "ember": require("./ember").default,
    // "pirates": require("./pirates").default,
}
